<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5 rounded p-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.utmtco.com\/storage\/assets\/kLLPswEEvUAqlaag5pDfINSu9CHgQXUL9n50Ajnq.webp1746427701.webp","alt":"utmtco"},...{}}' :style='""' class="col-6 mx-auto mb-5" ></m-img><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>Consulting   </template>
                </m-h3><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>In order to complete its sales staff in countries around the world, such as Asia, Europe, Africa, America, and especially neighboring countries, U-Tab Mehr Tandis Trading Co intends to grant qualified candidates sales and marketing representation for exporting its products. Therefore, all those who intend to cooperate with us should complete the form below or contact us via WhatsApp or Gmail.
   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container mb-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>   <m-h2 v-bind='{...{},...{}}' :style='"border-bottom:2px solid black;\nfont-size: 20px;\ndirection: ltr;"' class="mb-5 text-primary d-inline-block pb-3" >
                <template #default>To receive advice and contact, please complete the form below.   </template>
                </m-h2></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="justify-content-center row mx-auto form-wrapper-en" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 mx-auto" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-4","formId":3,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center my-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 text-center" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='"font-size: 16px;"' class="mb-4" >
                <template #default>Iran. Astan Khuzestan, Shahr Dezful, Khayaban Dr. Shariati﻿   </template>
                </m-h3><m-a v-bind='{...{"href":"","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>adel.tandis@gmail.com   </template>
                </m-a><m-a v-bind='{...{"href":"","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>info @utmtco.com   </template>
                </m-a><m-a v-bind='{...{"href":"tel:00989919010286","target":"_self"},...{}}' :style='"font-family: peyda-bold;"' class="d-block" >
                <template #default>00989919010286   </template>
                </m-a><m-a v-bind='{...{"href":"tel:00986142278157","target":"_self"},...{}}' :style='"font-family: peyda-bold;"' class="d-block" >
                <template #default>00986142278157   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mH2 from '@moeinmdn/miw-alpha-components/src/package/Tags/H2'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mH3,mP,mH2,mFormSingle1,mA },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
